import { toast } from 'react-toastify';

export default (response, options = {}) => {
  const { toast404 = true, toast401 = true } = options;
  const { status } = response;

  switch (status) {
    case 401:
      if (toast401)
        toast.error(
          "You aren't authorized to perform this action. Are you logged in? Please try refreshing."
        );
      break;
    case 403:
      toast.error(
        "You aren't authorized to perform this action. Are you logged in? Please try refreshing."
      );
      break;
    case 404:
      if (toast404) toast.error("Whoops! This record wasn't found.");
      break;
    case 422:
      break;
    default:
      toast.error(
        'Whoops! Something went wrong. Please refresh and try again.'
      );
  }
};
